import { render, staticRenderFns } from "./sureLogistPop.vue?vue&type=template&id=3d0c479b&scoped=true"
import script from "./sureLogistPop.vue?vue&type=script&lang=js"
export * from "./sureLogistPop.vue?vue&type=script&lang=js"
import style0 from "./sureLogistPop.vue?vue&type=style&index=0&id=3d0c479b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c479b",
  null
  
)

export default component.exports